import { render, staticRenderFns } from "./SignInH5.vue?vue&type=template&id=9c8cbc54&scoped=true&"
import script from "./SignInH5.vue?vue&type=script&lang=js&"
export * from "./SignInH5.vue?vue&type=script&lang=js&"
import style0 from "./SignInH5.vue?vue&type=style&index=0&id=9c8cbc54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8cbc54",
  null
  
)

export default component.exports